import { publicEncrypt } from 'crypto';
import { addMembershipPackageSectionWithPriceProduct, removeMembershipPackageSectionWithPriceProduct } from 'modules/membership';
import { Salesforce, User as UserTypes } from 'mxp-schemas';
import { Utils } from 'mxp-utils';

export const getPasswordBufferString = (value: string, pubKey: string) => {
  const buffer = publicEncrypt(
    {
      key: pubKey, // returned from graphql
      padding: 4,
      oaepHash: 'sha1',
    },
    Buffer.from(value, 'utf8')
  );

  return buffer.toString('base64');
};

export const isTokenProblemError = (error: any) =>
  error?.errorCode === UserTypes.UserErrorCodes.RESET_PASS_TOKEN_INCORRECT ||
  error?.errorCode === UserTypes.UserErrorCodes.RESET_PASS_TOKEN_EXPIRED;

export const getPersonAccountFlags = (
  cpaLicense: Salesforce.CPALicense,
  cpaLicenseList: { cpaLicense: Salesforce.CPALicense[] }
): Salesforce.PersonAccountFlags | null => {
  const findCpaLicense = cpaLicense?.id
    ? cpaLicenseList.cpaLicense.find((license: Salesforce.CPALicense) => license?.id === cpaLicense?.id)
    : {};

  if (Utils.isEqualHelper(findCpaLicense, cpaLicense)) {
    return null;
  }

  return {
    isNewUser: false,
    isProfileUpdate: false,
    modifiedRecords: [cpaLicense?.id],
    thirdPartyChangedFields: [Salesforce.thirdPartyFieldsType.CPA_LICENSE],
  };
};

export const processExistingSections = ({
  existingSections,
  membershipSections,
  customerSections,
  isRenewal,
  isRenewalSeason,
  membershipEvent,
  checkIfNotAlreadyRenewed,
  isProductForRenewal,
  dispatch
}: {
  existingSections: any[];
  membershipSections: any;
  customerSections: any[];
  isRenewal: boolean;
  isRenewalSeason: boolean;
  membershipEvent: any;
  checkIfNotAlreadyRenewed: (date: string) => boolean;
  isProductForRenewal: (date: string) => boolean;
  dispatch: (action: any) => void;
}) => {
  let renewedSect: any[] = [];

  existingSections.forEach(section => {
    const isSectionLapsed = customerSections.some(sect => sect.sku === section.variant.sku);
    const sectionMatchedProduct = membershipSections.listOfProductWithPrice.find(
      (item: ProductWithVariants) => item.variants[0].sku === section.variant.sku
    );

    if (!isSectionLapsed || !isRenewal) return;

    const hasMultipleTerms = section?.sectionTerms?.length > 1;
    const isRenewalEligibleByDate = section.zuoraTermEndDate
      ? checkIfNotAlreadyRenewed(section.zuoraTermEndDate)
      : false;
    const isRenewalEligibleBySeason =
      isRenewalSeason && !hasMultipleTerms && membershipEvent.isClickedCredentialsSectionsRenewal;

    const isEligibleForAutoAddToCart = isProductForRenewal(section?.zuoraTermEndDate || '');

    if (!(isRenewalEligibleByDate || isRenewalEligibleBySeason) || !isEligibleForAutoAddToCart) {
      const isAlreadyRemoved = renewedSect.some(renewSect => renewSect.productId === section.productId);

      if ((!isAlreadyRemoved || !membershipEvent.isClickedCredentialsSectionsRenewal) && section.subscriptionStatus) {
        dispatch(removeMembershipPackageSectionWithPriceProduct(section.variant.sku));
        renewedSect = [...renewedSect, section];
      }

      return;
    }

    dispatch(
      addMembershipPackageSectionWithPriceProduct(
        sectionMatchedProduct?.productId || section.productId,
        section.variant.sku
      )
    );
  });
}

type ProductWithVariants = {
  productId: string;
  variants: { sku: string }[];
};